import React from "react";

import { classnames } from "@culturehq/components";
import Carousel from "components/common/Carousel";

interface CarouselLibraryProps {
  assets: any[];
  className: string;
  onAssetClick: (asset: any) => Promise<void>;
  title: string;
  videoAssets?: boolean;
}

const LIBRARY_ELEMENT_WIDTH = 135;

const CarouselLibrary: React.FC<CarouselLibraryProps> = ({
  assets, className, onAssetClick, title, videoAssets
}) => (
  <div className={classnames(className, "library")}>
    <h4>{title}</h4>
    <Carousel className="library-assets" data={assets} elementWidth={LIBRARY_ELEMENT_WIDTH}>
      {assets.map((asset, index) => (
        <div
          key={index}
          className={classnames(`${className}__item-wrapper`, "library__item-wrapper")}
          onClick={() => onAssetClick(asset)}
          style={{
            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.3) 100%), url(${asset.posterUrl || asset.url})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            position: "relative"
          }}
          role="button"
          tabIndex={0}
        >
          {videoAssets ? (
            <video
              src={asset.url}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
              onMouseEnter={e => (e.target as HTMLVideoElement).play()}
              onMouseLeave={e => {
                const videoElement = e.target as HTMLVideoElement;
                videoElement.pause();
                videoElement.currentTime = 0; // Restart video to the beginning
              }}
              poster={asset.posterUrl}
              muted
              loop
            />
          ) : null}
        </div>
      ))}
    </Carousel>
  </div>
);

export default CarouselLibrary;
